import { useEffect } from 'react'
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'
import Button from '../../shared/components/Button/Button'
import Input from '../../shared/components/form/input'

const STATUS_OPTIONS = [
    { value: 'all', label: 'Todos' },
    { value: 'Criado', label: 'Criado' },
    { value: 'Aguardando Resposta', label: 'Aguardando Resposta' },
    { value: 'Aprovada', label: 'Aprovada' },
    { value: 'Reprovada', label: 'Reprovada' },
]

const PAYMENT_OPTIONS = [
    { value: 'all', label: 'Todos' },
    { value: 'inCash', label: 'Á vista' },
    { value: 'instalment', label: 'Parcelado' },
]

function BudgetFilterModal({ filters, onChange, onClear, onClose }) {

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose() }
        document.addEventListener('keydown', onKey)
        return () => document.removeEventListener('keydown', onKey)
    }, [onClose])

    return (
        <div className="fm-overlay" onClick={onClose}>
            <div className="fm-box" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="fm-header">
                    <div className="fm-header-top">
                        <div className="fm-header-left">
                            <FaFilter size={24} className="fm-header-icon" />
                            <div>
                                <p className="fm-title">Filtrar orçamentos</p>
                                <span className="fm-accent" />
                            </div>
                        </div>
                        <button className="fm-close shd-modal-close" onClick={onClose}>X</button>
                    </div>
                    <div className="fm-header-actions">
                        <Button variant="cancel" icon={VscClearAll} onClick={onClear}>Limpar</Button>
                    </div>
                </div>

                {/* ── Body ── */}
                <div className="fm-body">

                    <div className="fm-section">
                        <span className="fm-label">Status</span>
                        <div className="fm-status-row">
                            {STATUS_OPTIONS.map((opt) => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.status === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('status', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Forma de Pagamento</span>
                        <div className="fm-status-row">
                            {PAYMENT_OPTIONS.map((opt) => (
                                <button
                                    key={opt.value}
                                    className={`fm-status-opt ${filters.paymentMethod === opt.value ? 'fm-status-opt-active' : ''}`}
                                    onClick={() => onChange('paymentMethod', opt.value)}
                                >
                                    {opt.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="fm-section">
                        <span className="fm-label">Data de Criação</span>
                        <div className="fm-date-row">
                            <Input
                                type="date"
                                name="dateFrom"
                                text="De"
                                value={filters.dateFrom}
                                handleOnChange={(e) => onChange('dateFrom', e.target.value)}
                            />
                            <Input
                                type="date"
                                name="dateTo"
                                text="Até"
                                value={filters.dateTo}
                                handleOnChange={(e) => onChange('dateTo', e.target.value)}
                            />
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default BudgetFilterModal
